var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"incentive-pendant"},[_c('img',{staticClass:"incentive-pendant-image",attrs:{"src":_vm.incentiveEntryImage},on:{"click":_vm.handleClickPendant}}),_vm._v(" "),_c('img',{staticClass:"incentive-pendant-close",attrs:{"src":_vm.IncentiveCloseImage},on:{"click":_vm.handleClose}})])
}
var staticRenderFns = []

export { render, staticRenderFns }